import { FORM_BUSINESS_TYPE_SUBMIT } from "actions/businessStateActionTypes";

export function submitBusinessDetailsForm(payload) {
  return { type: FORM_BUSINESS_TYPE_SUBMIT, payload };
}
